import { useState } from 'react';
import styled from 'styled-components';
import { checkInternet } from './NetworkStatusLamp.jsx';
import Button from '../ui/Button.jsx';
import { ReactComponent as IconLogo } from '../assets/icons/icon-logo.svg';

const OfflineFallback = () => {
  const [checking, setChecking] = useState(false);
  const [message, setMessage] = useState('Нет соединения с интернетом. Проверьте сеть или попробуйте обновить страницу.');

  const handleRetry = async () => {
    setChecking(true);
    try {
      const state = await checkInternet({ force: true });
      if (state.isOnline && state.isReallyOnline) {
        window.location.reload();
      } else {
        setMessage('Интернет по-прежнему недоступен. Попробуйте позже.');
      }
    } catch (e) {
      setMessage('Ошибка при проверке сети. Попробуйте ещё раз.');
    } finally {
      setChecking(false);
    }
  };

  return (
    <Wrapper>
      <Card role="alert">
        <LogoWrap>
          <IconLogo />
        </LogoWrap>
        <Title>Нет подключения к интернету</Title>
        <Desc>{message}</Desc>
        <Actions>
          <Button type="primary" size="medium" onClick={() => window.location.reload()}>Обновить страницу</Button>
          <Button type="default" size="medium" onClick={handleRetry} disabled={checking}>{checking ? 'Проверка...' : 'Проверить подключение'}</Button>
        </Actions>
      </Card>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, rgba(255,255,255,0.98), rgba(250,250,250,0.98));
  z-index: 2000;
`;

const Card = styled.div`
  width: 100%;
  max-width: 640px;
  padding: 32px;
  border-radius: 10px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.12);
  background: #fff;
  text-align: center;
`;

const LogoWrap = styled.div`
  display:flex;
  align-items:center;
  justify-content:center;
  margin: 0 auto 24px auto;
  fill: #EA394B;
  svg {
    width: 200px !important;
    height: auto !important;
  }
`;

const Title = styled.h2`
  margin: 8px 0 8px 0;
  font-size: 22px;
  color: #222;
`;

const Desc = styled.p`
  margin: 0 0 18px 0;
  color: #555;
  line-height: 1.4;
`;

const Actions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 6px;
`;

export default OfflineFallback;
